import { connect } from "react-redux";
import MobileMenu from "./MobileMenu";
import { hideMobileMenu } from "../../actions/globalActions";
import type { AppDispatch, RootState } from "../../store";

const mapStateToProps = (state: RootState) => {
  const { isMobileMenuVisible } = state.global;
  const { isLoggedIn } = state.login;
  return {
    isMobileMenuVisible,
    isLoggedIn
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    hideMobileMenu: () => {
      dispatch(hideMobileMenu());
    }
  };
};

const MobileMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileMenu);

export default MobileMenuContainer;
